setTimeout(() => {
    const searchModals = document.querySelectorAll('search-modal');
    searchModals[1].remove();

    const modalObserver = new MutationObserver(() => {
        if (searchModals[0].classList.contains('d-none') || mobileMenu.classList.contains('mobile-menu-active')) {
            document.querySelector('body').classList.remove('body-static');
            document.querySelector('#site-overlay').classList.remove('overlay--body-active');
        } else if (!searchModals[0].classList.contains('d-none') || !mobileMenu.classList.contains('mobile-menu-active')) {
            document.querySelector('body').classList.add('body-static');
            document.querySelector('#site-overlay').classList.add('overlay--body-active');
        }
    });

    modalObserver.observe(searchModals[0], { attributes: true, attributeFilter: ['class'] });

    const mobileMenu = document.querySelector('.mobile-navbar-menu__cont')

    const mobileMenuObserver = new MutationObserver(() => {
        if (mobileMenu.classList.contains('mobile-menu-active')) {
            
            document.querySelector('body').classList.add('body-static');
            document.querySelector('html').classList.add('body-static');
            document.querySelector('.new-header__cont').style.zIndex = "99999999";
            if (document.querySelector("#shopify-chat")) {
                document.querySelector("#shopify-chat").style.position = "relative";
                document.querySelector("#shopify-chat").style.zIndex = "100";
            }
        } else {
            
            document.querySelector('body').classList.remove('body-static');
            document.querySelector('html').classList.remove('body-static');
            document.querySelector('.new-header__cont').style.zIndex = "1040";
            setTimeout(() => {
                if (document.querySelector("#shopify-chat")) {
                    document.querySelector("#shopify-chat").style.position = "static";
                    document.querySelector("#shopify-chat").style.zIndex = "auto";
                }
            }, 500)
        }
    })

    mobileMenuObserver.observe(mobileMenu, { attributes: true, attributeFilter: ['class'] })
}, 500);

document.addEventListener('scroll', () => {
    const newHeader = document.querySelector('.new-header__cont');
    const mobileMenu = document.querySelector(".mobile-navbar-menu__cont")
    if (window.scrollY < 100) {
        newHeader.classList.remove('topbar-hidden');
        mobileMenu.style.top = "0px";
    } else {
        newHeader.classList.add('topbar-hidden');
        mobileMenu.style.top = "42px";
    }
});

document.addEventListener('mouseup', (e) => {
    const mobileMenuCont = document.querySelector('.mobile-navbar-menu__cont');
    const mobileMenu = document.querySelector('.mobile-navbar-menu');
    const allSubMenuConts = document.querySelectorAll('.menu__option-submenu-cont');
    const allSubMenus = document.querySelectorAll('.menu__option-submenu');

    function openModal() {
        mobileMenuCont.classList.add('mobile-menu-active');
        mobileMenu.classList.add('mobile-menu-active');
    }

    function closeModal() {
        mobileMenuCont.classList.remove('mobile-menu-active');
        mobileMenu.classList.remove('mobile-menu-active');
    }

    function closeSubmenus() {
        allSubMenuConts.forEach(subMenuCont => subMenuCont.classList.remove('menu__option-submenu-active'));
        allSubMenus.forEach(submenu => submenu.classList.remove('menu__option-submenu-active'));
    }

    if (e.target.closest('.mobile-hamburger-menu')) {
        openModal();
    }

    if (e.target.closest('.close-mobile-navbar') || e.target.matches('.mobile-navbar-menu__cont') || e.target.matches('.close-mobile-navbar__submenu')) {
        closeModal();
        setTimeout(() => { closeSubmenus(); }, 300)
    }

    if (e.target.closest('.menu__option-submenu-button')) {
        const subMenuCont = e.target.closest('.menu__option-submenu-button').querySelector('.menu__option-submenu-cont');
        const submenu = e.target.closest('.menu__option-submenu-button').querySelector('.menu__option-submenu');

        subMenuCont.classList.add('menu__option-submenu-active');
        submenu.classList.add('menu__option-submenu-active');
    }

    if (e.target.closest('.close-submenu')) {
        closeSubmenus();
    }

    if (e.target.closest('.desktop-login-btn') || e.target.closest('.menu__content-bottom-btn')) {
        e.preventDefault();
    }
})